import {getNewPaymentTermsLambda} from './functionSignatures';

/**
 * Verify if the spender or requester has permission for fetching data from the SAP API.
 * @param {BrickContext} $
 * @param {Object} spender
 * @param {Object} requester
 * @param {Function} setUserIdToCallSAPAPIs
 * @param {Function} getNewPaymentTerms
 */
export const verifySAPApiPermission = ($, spender, requester, setUserIdToCallSAPAPIs, getNewPaymentTerms) => {
    // Check if both spender and requester values are empty
    if (!spender.value && !requester.value) {
        setUserIdToCallSAPAPIs('');
        return;
    }

    // Check if spender and requester are the same
    if (spender.value === requester.value) {
        getNewPaymentTermsLambda($, getNewPaymentTerms, 'US16', spender.value, 'US10', () => {
            setUserIdToCallSAPAPIs(spender.value);
        }, () => {
            setUserIdToCallSAPAPIs(spender.value);
        });
        return;
    }

    // Check if spender is empty
    if (!spender.value) {
        getNewPaymentTermsLambda($, getNewPaymentTerms, 'US16', requester.value, 'US10', () => {
            setUserIdToCallSAPAPIs(requester.value);
        }, () => {
            setUserIdToCallSAPAPIs(requester.value);
        });
        return;
    }

    getNewPaymentTermsLambda($, getNewPaymentTerms, 'US16', spender.value, 'US10', () => {
        setUserIdToCallSAPAPIs(spender.value);
    }, () => {
        if (!requester.value) {
            setUserIdToCallSAPAPIs(spender.value);
            return;
        }
        getNewPaymentTermsLambda($, getNewPaymentTerms, 'US16', requester.value, 'US10', () => {
            setUserIdToCallSAPAPIs(requester.value);
        }, () => {
            setUserIdToCallSAPAPIs(spender.value);
        });
    });
};

/**
 * Verify if the spender or requester has permission for fetching data from the SAP API.
 * @param {BrickContext} $
 * @param {Object} spender
 * @param {Object} requester
 * @param {Function} getNewPaymentTerms
 * @return {string}
 */
export const verifySAPApiPermissionMassSubmit = async ($, spender, requester, getNewPaymentTerms) => {
    // Helper function to call getNewPaymentTermsLambda and return a Promise
    const getNewPaymentTermsLambdaAsync = ($, getNewPaymentTerms, region, value, otherRegion) => {
        return new Promise((resolve, reject) => {
            getNewPaymentTermsLambda($, getNewPaymentTerms, region, value, otherRegion, () => {
                resolve(value);
            }, () => {
                resolve(value);
            });
        });
    };

    if (!spender.value && !requester.value) {
        return '';
    }

    if (spender.value === requester.value) {
        return await getNewPaymentTermsLambdaAsync($, getNewPaymentTerms, 'US16', spender.value, 'US10');
    }

    if (!spender.value) {
        return await getNewPaymentTermsLambdaAsync($, getNewPaymentTerms, 'US16', requester.value, 'US10');
    }

    const spenderResult = await getNewPaymentTermsLambdaAsync($, getNewPaymentTerms, 'US16', spender.value, 'US10');

    if (!requester.value) {
        return spenderResult;
    } else {
        const requesterResult = await getNewPaymentTermsLambdaAsync($, getNewPaymentTerms, 'US16', requester.value, 'US10');
        return requesterResult;
    }
};
